import "./ComicPricesModal.scss";

import ComicPricesModal from "./ComicPricesModal";

export default ComicPricesModal;
